"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ButtonStates = _interopRequireDefault(require("../constants/ButtonStates"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UILoadingButton = _interopRequireDefault(require("UIComponents/button/UILoadingButton"));

var _UIIconHolder = _interopRequireDefault(require("UIComponents/icon/UIIconHolder"));

var _default = _react.default.createClass({
  displayName: "SaveButton",
  propTypes: {
    buttonState: _react.default.PropTypes.oneOf([_ButtonStates.default.INITIAL, _ButtonStates.default.SAVING, _ButtonStates.default.COMPLETE]).isRequired,
    className: _react.default.PropTypes.string,
    disabled: _react.default.PropTypes.bool,
    onClick: _react.default.PropTypes.func.isRequired,
    textPath: _react.default.PropTypes.string.isRequired,
    use: _react.default.PropTypes.string
  },
  getDefaultProps: function getDefaultProps() {
    return {
      className: '',
      disabled: false,
      use: 'primary'
    };
  },
  render: function render() {
    var _this$props = this.props,
        buttonState = _this$props.buttonState,
        className = _this$props.className,
        disabled = _this$props.disabled,
        onClick = _this$props.onClick,
        textPath = _this$props.textPath,
        use = _this$props.use;
    var saveButtonClasses = (0, _classnames.default)('save-button', className);
    return _react.default.createElement(_UILoadingButton.default, {
      className: saveButtonClasses,
      disabled: disabled,
      loading: buttonState === _ButtonStates.default.SAVING,
      onClick: onClick,
      use: use
    }, buttonState === _ButtonStates.default.COMPLETE && _react.default.createElement(_UIIconHolder.default, {
      name: "success"
    }), _react.default.createElement(_FormattedMessage.default, {
      message: textPath + ".saveButtonText." + buttonState
    }));
  }
});

exports.default = _default;
module.exports = exports.default;